import React from "react";
import Loader from "../../components/common/Loader";
import Menu from "../../components/innerpage/Menu";
import StartButton from "../../components/home5_residence/StartButton";
import Overview from "../../components/innerpage/projects/overview";
import Navbar from "../../components/home1/Navbar";
import Header from "../../components/home1/Header";
import Footer2 from "../../components/home2/Footer";

import { Helmet } from "react-helmet";

function ProjectPage() {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <link rel="stylesheet" href="/home1/assets/css/home_1_style.css" />
        <link
          rel="stylesheet"
          href="/home5_residence/assets/css/home_5_style.css"
        />
        <link rel="stylesheet" href="/home10/assets/css/home_10_style.css" />
        <link rel="stylesheet" href="/home2/assets/css/home_2_style.css" />

        <script src="/common/assets/js/common_js.js" defer></script>
        <script src="/home1/assets/js/home_1_scripts.js" defer></script>
        <script src="/home10/assets/js/home_10_scripts.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>

        <script
          src="/home5_residence/assets/js/home_5_scripts.js"
          defer
        ></script>
      </Helmet>
      <body className="inner-pages-style1 portfolio-pg-style1 home-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content " id="scrollsmoother-container">
          <Navbar />

          <Header />

          <main>
            <Overview />
            <div className="portfolio-pg-style1">
              {/* <LatestCases /> */}
            </div>
          </main>
          <Footer2 />
        </div>
        <StartButton />
      </body>
    </>
  );
}

export default ProjectPage;
